function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n.cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:#1374ba;}.cls-7{fill:#48566b;}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 116.13,
  y1: 129.73,
  x2: 214.33,
  y2: 31.53,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#6d7888"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#48566b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 160.51,
  y1: 174.11,
  x2: 258.7,
  y2: 75.91,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 175.32,
  y1: 188.93,
  x2: 273.52,
  y2: 90.73,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 80.5,
  y1: 94.1,
  x2: 178.69,
  y2: -4.1,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 96.73,
  y1: 110.33,
  x2: 194.93,
  y2: 12.14,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M175.22,112.28a3.78,3.78,0,0,1-1.89,3.22c-.38.21-37.07,21.79-33.21,59.42l-7.35,1.63c-2.06-17.74,3.52-34.94,16.23-49.85a90.84,90.84,0,0,1,15.59-14.39c-20.81-14.14-28.34-31.25-30.94-43.51-3.05-14.36-.19-25.21-.07-25.67,0,0,0,0,0-.05l7.28,1.69c0,.1,0,.2-.06.31-.42,1.61-9.67,38.75,32.57,64A3.76,3.76,0,0,1,175.22,112.28Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M211.69,126.7c12.79,15,18.37,32.33,16.19,50.18l-7.31-1.95c3.87-37.64-32.83-59.22-33.21-59.43a3.75,3.75,0,0,1-.05-6.47c17.88-10.68,28.78-24.73,32.4-41.78a52.12,52.12,0,0,0,.16-22.16,3,3,0,0,1-.07-.43L227.06,43a.88.88,0,0,0,.05.15c.12.46,3,11.31-.07,25.67-2.6,12.26-10.12,29.37-30.94,43.51A90.84,90.84,0,0,1,211.69,126.7Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M237.4,187.24a17.26,17.26,0,0,1-5.33,3c-6.28,2.54-13.16,3.72-19.84,4.66A231.74,231.74,0,0,1,179.88,197c-16.55,0-34.62-.52-50.42-6.06-2.62-.92-6-2.06-7.53-4.54-1.67-2.67-.1-4.91,2.2-6.32a33,33,0,0,1,8.64-3.52l7.35-1.63.52-.11c12.89-2.46,26.14-3.19,39.24-3.19s27.45.33,40.69,3.31l7.31,1.95c.82.26,1.63.52,2.43.8a26.46,26.46,0,0,1,5.59,2.57,5.65,5.65,0,0,1,2.75,4.07A3.59,3.59,0,0,1,237.4,187.24Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M121.27,79.62a33.75,33.75,0,0,0-.32-4.53,52.81,52.81,0,0,0-1.44-7.46,44.43,44.43,0,0,0-1.38-4.33c-.4-1.08-1.81-3-1.81-4.15V41.79c0-2.77-.43-4.29-2.75-6-.71-.53-3-2.42-3.92-1.48V59.54c0,1.34-1.65,3.65-2.14,4.9a46,46,0,0,0-2.9,10.09c-.55,3.76-.2,8.35,2,11.55,2.88,4.13,9.08,3.93,12.25.24A10.09,10.09,0,0,0,121.27,79.62Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M256,24.43c-.51-.51-2.17-.71-2.83-.93l-24.09-7.93-31-10.19L186.85,1.66,183.46.55a6.83,6.83,0,0,0-5.13-.09L174.25,1.8l-25.41,8.36-29.37,9.67-10.13,3.33c-.88.29-3.18.58-3.85,1.28a2.57,2.57,0,0,0,0,3.74l73.1,23.43c2.5.8,4.55-.07,6.88-.81l9.19-2.95,28.92-9.27,26.27-8.42,6.18-2A2.6,2.6,0,0,0,256,24.43Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M181.32,77.46s22-1.84,24.72.65c0,0,6.67,5.49-24.06,25.37a85.6,85.6,0,0,1-21.41-16A34.62,34.62,0,0,1,155.05,80c-1-2-2.53-4.69-1.9-7,.47-1.72,2-1.82,3.56-1.84a19.34,19.34,0,0,1,5.35.78c2.9.78,5.46,2.45,8.28,3.3C170.34,75.23,178.43,77.66,181.32,77.46Z"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-6",
  cx: 181.01,
  cy: 123.56,
  r: 4.97,
  transform: "translate(-23.55 44.89) rotate(-13.28)"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-6",
  cx: 181.01,
  cy: 141.73,
  r: 7.9
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M197.33,159.85,181,152.4l-16.33,7.45c-16.33,7.45-16.33,14-16.33,14C149.65,183.65,181,183,181,183s31.35.65,32.65-9.16C213.66,173.84,213.66,167.3,197.33,159.85Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M8.92,290.42v1.35H.31V279.88H8.65v1.35H1.75v3.84H7.12v1.35H1.75v4Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M22.58,285.83c0,3.81-2.25,5.94-6,5.94H12.77V279.88h3.84C20.33,279.88,22.58,282,22.58,285.83Zm-1.51,0c0-2.89-1.6-4.6-4.32-4.6H14.21v9.19h2.54C19.47,290.42,21.07,288.71,21.07,285.83Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M35.92,287.34c0,3.06-1.65,4.61-4.66,4.61s-4.66-1.55-4.66-4.61v-7.46H28V287c0,2.48,1,3.62,3.22,3.62s3.22-1.14,3.22-3.62v-7.1h1.44Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M45.44,292c-3.38,0-5.51-2.36-5.51-6.12s2.16-6.13,5.48-6.13A4.56,4.56,0,0,1,50,282.48l-1.43.66a3,3,0,0,0-3.07-2.09c-2.43,0-4.07,1.77-4.07,4.78s1.53,4.77,4,4.77a3.31,3.31,0,0,0,3.35-2.42l1.44.54A4.88,4.88,0,0,1,45.44,292Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M60.65,288.47H55.27L54,291.77H52.5l4.63-11.89h1.71l4.61,11.89H61.92Zm-.52-1.35-1.6-4.21L58,281.25h0l-.53,1.6-1.62,4.27Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M73.56,281.23H69.42v10.54H68V281.23H63.84v-1.35h9.72Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M78.49,291.77H77.05V279.88h1.44Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M93.65,285.83c0,3.76-2.12,6.12-5.51,6.12s-5.51-2.36-5.51-6.12,2.13-6.13,5.51-6.13S93.65,282.06,93.65,285.83Zm-9.51,0c0,3,1.53,4.77,4,4.77s4-1.79,4-4.77-1.53-4.78-4-4.78S84.14,282.84,84.14,285.83Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M107.12,291.77h-1.79l-5-8-1.26-2.34h0l.08,1.91v8.39H97.79V279.88h1.78l5,7.93,1.28,2.37h0l-.07-1.91v-8.39h1.37Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M127,281.23h-4.14v10.54h-1.44V281.23h-4.14v-1.35H127Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M139.05,290.42v1.35h-8.61V279.88h8.34v1.35h-6.9v3.84h5.37v1.35h-5.37v4Z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M147.42,292c-3.39,0-5.51-2.36-5.51-6.12s2.16-6.13,5.47-6.13a4.55,4.55,0,0,1,4.61,2.78l-1.42.66a3,3,0,0,0-3.08-2.09c-2.43,0-4.07,1.77-4.07,4.78s1.53,4.77,4,4.77a3.32,3.32,0,0,0,3.35-2.42l1.44.54A4.9,4.9,0,0,1,147.42,292Z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M165.28,279.88v11.89h-1.45v-5.35h-6.44v5.35H156V279.88h1.44v5.19h6.44v-5.19Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M179.46,291.77h-1.78l-5-8-1.26-2.34h0l.07,1.91v8.39h-1.37V279.88h1.79l5,7.93,1.28,2.37h0l-.07-1.91v-8.39h1.37Z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M194.62,285.83c0,3.76-2.13,6.12-5.51,6.12s-5.51-2.36-5.51-6.12,2.12-6.13,5.51-6.13S194.62,282.06,194.62,285.83Zm-9.51,0c0,3,1.53,4.77,4,4.77s4-1.79,4-4.77-1.53-4.78-4-4.78S185.11,282.84,185.11,285.83Z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M207,290.42v1.35h-8.25V279.88h1.45v10.54Z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M220.38,285.83c0,3.76-2.13,6.12-5.51,6.12s-5.51-2.36-5.51-6.12,2.12-6.13,5.51-6.13S220.38,282.06,220.38,285.83Zm-9.51,0c0,3,1.53,4.77,4,4.77s4-1.79,4-4.77-1.53-4.78-4-4.78S210.87,282.84,210.87,285.83Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M234.18,285.77v6H233.1l0-1.61A4.09,4.09,0,0,1,229.3,292c-3.38,0-5.51-2.36-5.51-6.12s2.22-6.13,5.55-6.13a4.76,4.76,0,0,1,4.75,2.72l-1.31.72a3.39,3.39,0,0,0-3.44-2.09c-2.41,0-4,1.79-4,4.78s1.4,4.77,4.05,4.77c2,0,3.51-1,3.51-3.06v-.42h-3.78v-1.35Z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M242.26,287.12v4.65h-1.44v-4.65l-4.25-7.24h1.72l3.25,5.76,3.26-5.76h1.71Z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M264.37,282.22l-1.24,1a3.18,3.18,0,0,0-3.33-2.18c-1.89,0-2.94.89-2.94,2s.79,1.67,3.3,2.11c3.18.54,4.32,1.55,4.32,3.38,0,2-1.82,3.39-4.59,3.39a5.41,5.41,0,0,1-5-2.58l1.24-1a3.84,3.84,0,0,0,3.8,2.24c1.84,0,3.06-.69,3.06-2,0-1-.77-1.62-3.27-2.05-3.21-.56-4.36-1.53-4.36-3.35s1.67-3.53,4.43-3.53A4.83,4.83,0,0,1,264.37,282.22Z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M278.77,285.83c0,3.76-2.12,6.12-5.51,6.12s-5.51-2.36-5.51-6.12,2.13-6.13,5.51-6.13S278.77,282.06,278.77,285.83Zm-9.51,0c0,3,1.53,4.77,4,4.77s4-1.79,4-4.77-1.53-4.78-4-4.78S269.26,282.84,269.26,285.83Z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M291.16,290.42v1.35h-8.25V279.88h1.44v10.54Z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M303.56,287.34c0,3.06-1.66,4.61-4.67,4.61s-4.66-1.55-4.66-4.61v-7.46h1.44V287c0,2.48,1,3.62,3.22,3.62s3.23-1.14,3.23-3.62v-7.1h1.44Z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M316.64,281.23H312.5v10.54h-1.44V281.23h-4.14v-1.35h9.72Z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M321.58,291.77h-1.45V279.88h1.45Z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M336.73,285.83c0,3.76-2.12,6.12-5.51,6.12s-5.51-2.36-5.51-6.12,2.13-6.13,5.51-6.13S336.73,282.06,336.73,285.83Zm-9.5,0c0,3,1.53,4.77,4,4.77s4-1.79,4-4.77-1.53-4.78-4-4.78S327.23,282.84,327.23,285.83Z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M350.2,291.77h-1.78l-5-8-1.26-2.34h0l.07,1.91v8.39h-1.37V279.88h1.78l5,7.93,1.27,2.37h0l-.07-1.91v-8.39h1.37Z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M363.46,282.22l-1.24,1a3.18,3.18,0,0,0-3.33-2.18c-1.89,0-2.93.89-2.93,2s.79,1.67,3.29,2.11c3.19.54,4.32,1.55,4.32,3.38,0,2-1.82,3.39-4.59,3.39a5.38,5.38,0,0,1-5-2.58l1.24-1a3.84,3.84,0,0,0,3.8,2.24c1.83,0,3.06-.69,3.06-2,0-1-.78-1.62-3.28-2.05-3.2-.56-4.36-1.53-4.36-3.35s1.68-3.53,4.43-3.53A4.82,4.82,0,0,1,363.46,282.22Z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M35.76,229v39.6H25.44v-16H10.32v16H0V229H10.32V244.7H25.44V229Z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M81.66,248.84c0,12.78-7.32,20.39-19.38,20.39s-19.44-7.61-19.44-20.39,7.38-20.4,19.44-20.4S81.66,236.06,81.66,248.84Zm-28.26,0c0,8.1,3.12,12.3,8.88,12.3s8.82-4.2,8.82-12.3-3.12-12.3-8.82-12.3S53.4,240.74,53.4,248.84Z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M123.42,252.5c0,11.16-6,16.73-17.7,16.73S88,263.66,88,252.5V229H98.4v23.64c0,5.7,2.4,8.46,7.32,8.46s7.44-2.76,7.44-8.46V229h10.26Z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M147.85,254.18h-6.18v14.46H131.53V229h18.9c9.54,0,14.94,4.44,14.94,12.6,0,5.76-2.7,9.66-7.68,11.46l10,15.54h-11.4Zm-6.18-7.32h7c4.38,0,6.3-1.5,6.3-5s-1.92-5-6.3-5h-7Z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M208,247.22v21.42h-7.2l-.3-4.62c-2.16,3.29-5.88,5.21-11.34,5.21-10.68,0-18.42-7.19-18.42-20.33,0-12.78,7.56-20.46,19.74-20.46,9,0,14.28,3,17.46,10.14l-9.54,3.78c-1-4-3.84-5.82-7.62-5.82-6,0-9.42,4.14-9.42,12.3,0,8.46,3.3,12.48,9.72,12.48,4.68,0,8.16-2.1,8.16-6.54v-.6h-9.84v-7Z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M246,260.66v8H215.83V229h10.32v31.62Z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M274.63,259.7H261l-2.76,8.94H247.81L261.73,229h12.36L288,268.64H277.33Zm-2.16-7-2.88-9.48L267.85,237h-.12l-1.62,6.18-2.94,9.54Z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M324.91,235.58l-5.82,6.72c-2.64-4-6-5.82-11-5.82-4.26,0-6.48,1.68-6.48,4,0,2,2.16,3.12,7.8,4.14,11,2,15.24,5.52,15.24,12.48,0,7.74-7.2,12.17-16.74,12.17-9.36,0-14.28-2.39-18.18-6.71l5.28-7.2c3.24,4.5,7.08,5.88,12.36,5.88,4.44,0,6.6-1.32,6.6-3.6,0-1.86-2.28-2.88-7.68-3.9-9.36-1.86-15.42-4.62-15.42-12.36,0-7.44,6.18-12.9,17-12.9C315.31,228.44,320.35,230.48,324.91,235.58Z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M363.56,235.58l-5.82,6.72c-2.64-4-6-5.82-11-5.82-4.26,0-6.48,1.68-6.48,4,0,2,2.16,3.12,7.8,4.14,11,2,15.24,5.52,15.24,12.48,0,7.74-7.2,12.17-16.74,12.17-9.36,0-14.28-2.39-18.18-6.71l5.28-7.2c3.24,4.5,7.08,5.88,12.36,5.88,4.44,0,6.6-1.32,6.6-3.6,0-1.86-2.28-2.88-7.68-3.9-9.36-1.86-15.42-4.62-15.42-12.36,0-7.44,6.18-12.9,17-12.9C354,228.44,359,230.48,363.56,235.58Z"
});

var SvgHets = function SvgHets(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 363.57 291.95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHets, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hets.f6f4652e.svg";
export { ForwardRef as ReactComponent };